import type { Car } from "@/data/cars";
import { CarCard } from "@/components/site/CarCard";
import { cn } from "@/lib/utils";

export function CarGrid({
  cars,
  view = "grid",
  className,
}: {
  cars: Car[];
  view?: "grid" | "list";
  className?: string;
}) {
  if (cars.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-border p-12 text-center">
        <p className="font-display text-lg font-semibold">No cars match your filters</p>
        <p className="mt-1 text-sm text-muted-foreground">
          Try widening the price range or clearing a few filters.
        </p>
      </div>
    );
  }

  return (
    <div
      className={cn(
        view === "grid"
          ? "grid gap-6 sm:grid-cols-2 xl:grid-cols-3"
          : "flex flex-col gap-6",
        className,
      )}
    >
      {cars.map((car) => (
        <CarCard key={car.id} car={car} view={view} />
      ))}
    </div>
  );
}
